/**
 * Created by ivan on 23.03.18.
 */

const CakeAnimation = BaseAnimation.extend({ 
    ctor: function (bundle) {
        this._super(bundles[bundle].jsons[`${bundle}_splash_json`]);
    }
});

CakeAnimation.factory = function (bundle) {
    return cleverapps.pool.hasObject(CakeAnimation) ? cleverapps.pool.getFromPool(CakeAnimation) : new CakeAnimation(bundle);
};